import React, { useMemo } from 'react';
import Badge from '@amzn/awsui-components-core/badge';
import Box from '@amzn/awsui-components-core/box';
import Table from '@amzn/awsui-components-core/table';
import { useApiCalls } from 'src/components/star-grid/hooks/useApiCalls';
import { useStarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import { apiCallRows, type ApiCallRow } from 'src/components/star-grid/utils/apiCallSummary';
import { formatDurationMs } from 'src/components/star-grid/utils/reportStatus';

/** The StarGrid API calls the current page made, newest first, repeats flagged. */
export const ReportStatsApiCalls: React.FC = () => {
  const text = useStarGridText();
  const calls = useApiCalls();
  const rows = useMemo(() => apiCallRows(calls), [calls]);
  return (
    <Table<ApiCallRow>
      variant="embedded"
      wrapLines
      items={rows}
      empty={text('statsNoApiCalls')}
      columnDefinitions={[
        {
          id: 'call',
          header: text('statsCall'),
          cell: (row) => (
            <>
              <Box variant="code" fontSize="body-s">
                {row.method} {row.path}
              </Box>
              <Box variant="small">
                {new Date(row.startedAt).toLocaleTimeString()} · {row.error ?? row.status ?? '—'}
                {row.cacheBypassed ? ` · ${text('statsCacheBypassed')}` : ''} {row.repeats > 1 && <Badge color="red">×{row.repeats}</Badge>}
              </Box>
            </>
          )
        },
        { id: 'total', header: text('statsBrowserTime'), cell: (row) => formatDurationMs(row.durationMs) },
        { id: 'server', header: text('statsServerTime'), cell: (row) => formatDurationMs(row.serverMs) },
        {
          id: 'starrocks',
          header: text('statsStarRocksTime'),
          cell: (row) => (row.starRocksQueries ? `${formatDurationMs(row.starRocksMs)} (${row.starRocksQueries})` : '—')
        }
      ]}
    />
  );
};
